import { Component } from '@angular/core';
import { TaiaoDashboardLayoutComponentBase } from '@app/client/classes/taiao-dashboard-layout-component.class';
import * as ChartConfig from './charts.config';
@Component({
  selector: 'app-client-custom-widget-layout',
  templateUrl: './custom-widget-layout.component.html',
  styleUrls: ['../../default/taiao-dashboard-layout/taiao-dashboard-layout.component.scss'],
})
export class paepae_CustomWidgetLayoutComponent extends TaiaoDashboardLayoutComponentBase {
  ChartConfig = ChartConfig;

  get normalizedSiteName(): string {
    return (this.site?.name ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }
}
